import { Users, Drum, Speaker, MapPin, Mic, Music, Flower2 } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    icon: Users,
    title: "Team Building",
    desc: "High-energy corporate experiences that fuse rhythm, play and purpose — turning colleagues into tribes.",
  },
  {
    icon: Drum,
    title: "Drum Circle",
    desc: "Our signature. Hundreds of drums, one heartbeat. Facilitated circles that electrify any gathering.",
  },
  {
    icon: Speaker,
    title: "Venue Production",
    desc: "Stage, sound, light and spectacle — full technical production that transforms spaces into experiences.",
  },
  {
    icon: MapPin,
    title: "Venue Finding",
    desc: "From rooftop soirées to grand convention halls, we scout and secure the perfect stage for your story.",
  },
  {
    icon: Mic,
    title: "Artist Management",
    desc: "End-to-end management of performers — bookings, contracts, riders and flawless on-ground execution.",
  },
  {
    icon: Music,
    title: "Band Management",
    desc: "Live bands curated and managed for weddings, corporates and festivals — the right sound, every time.",
  },
  {
    icon: Flower2,
    title: "Wedding Decor",
    desc: "Floral mandaps, draped ceilings, candlelit receptions and themed stages — decor that turns venues into fairytales.",
    wide: true,
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 sm:py-36 px-6 lg:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <span
            data-testid="services-eyebrow"
            className="text-xs sm:text-sm uppercase tracking-[0.3em] text-[#d4af37] font-semibold mb-4 block"
          >
            What We Orchestrate
          </span>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white max-w-2xl leading-tight">
            Seven crafts. <span className="gold-text">One standing ovation.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[rgba(212,175,55,0.15)]">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i % 3} className={`h-full ${s.wide ? "lg:col-span-3" : ""}`}>
              <article
                data-testid={`service-card-${i + 1}`}
                className={`group relative h-full bg-[#09090b] hover:bg-[#121215] p-10 transition-colors duration-500 ${s.wide ? "lg:flex lg:items-center lg:gap-10" : ""}`}
              >
                <span className="absolute top-8 right-8 font-cinzel text-sm text-zinc-600 group-hover:text-[#d4af37] transition-colors duration-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <s.icon
                  size={34}
                  strokeWidth={1.25}
                  className="text-[#d4af37] mb-8 group-hover:scale-110 group-hover:-rotate-6 transition-transform duration-500"
                />
                <h3 className="font-serif-display text-2xl font-semibold text-white mb-3">
                  {s.title}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
                <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-gradient-to-r from-[#f3e5ab] via-[#d4af37] to-[#aa771c] group-hover:w-full transition-all duration-700 ease-out" />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
